export default {
  projects: ({ projects }) => projects,
  projectMasters: ({ projectMasters }) => projectMasters,
  formInput: ({ formInput }) => formInput,
}
